import React from "react";
import { Dialog } from "Components";

type ConfirmDisableSSOProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmDisableSSO = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmDisableSSOProps): React.JSX.Element => {
  return (
    <Dialog
      title="Disable SSO?"
      confirmText="Disable SSO"
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={onConfirm}
      cancelButtonColor="primary"
      confirmButtonColor="error"
      dangerZone="disable-sso"
    >
      <p>Are you sure you want to disable SSO and revert to local login?</p>
      <p>
        This means all role and group management will be done in Spectra Assure
        only.
      </p>
      <p>Additionally, all personal access tokens will be revoked.</p>
    </Dialog>
  );
};

export default ConfirmDisableSSO;
